import {AmplitudeItemListName, getAmplitudeViewItemEventProperties, IAmplitudeViewItemOffer} from "./get_amplitude_view_item_event_properties";

export type AmplitudeOfferListingTileEntryPoint = "tile" | "see_apartments";
export type AmplitudeOfferTileLocation =
    | "investment_page"
    | "listing_page"
    | "property_page"
    | "rp_apartment_prices_city"
    | "rp_apartment_prices_district"
    | "rp_apartment_prices_address"
    | "rp_apartment_prices_country";

export interface IAmplitudeOfferListingTileContext {
    entryPoint: AmplitudeOfferListingTileEntryPoint | null;
    itemAddress: string | null;
    location: AmplitudeOfferTileLocation | null;
    usp: string | null;
}

export interface IGetAmplitudeOfferSelectItemEventPropertiesParams {
    offer: IAmplitudeViewItemOffer;
    index: number;
    itemListId?: string;
    itemListName?: AmplitudeItemListName;
    listingTileContext?: IAmplitudeOfferListingTileContext;
}

export const getAmplitudeOfferSelectItemEventProperties = ({
    offer,
    index,
    itemListId,
    itemListName,
    listingTileContext
}: IGetAmplitudeOfferSelectItemEventPropertiesParams): Record<string, string | string[] | number | null> => ({
    ...getAmplitudeViewItemEventProperties({
        offer,
        itemListId,
        itemListName
    }),
    property_id: null,
    item_address: listingTileContext?.itemAddress ?? null,
    usp: listingTileContext?.usp ?? null,
    entry_point: listingTileContext?.entryPoint ?? null,
    location: listingTileContext?.location ?? null,
    index
});
import {AmplitudeItemListName, getAmplitudeViewItemEventProperties, IAmplitudeViewItemOffer} from "./get_amplitude_view_item_event_properties";

export type AmplitudeOfferListingTileEntryPoint = "tile" | "see_apartments";
export type AmplitudeOfferTileLocation =
    | "investment_page"
    | "listing_page"
    | "property_page"
    | "rp_apartment_prices_city"
    | "rp_apartment_prices_district"
    | "rp_apartment_prices_address"
    | "rp_apartment_prices_country";

export interface IAmplitudeOfferListingTileContext {
    entryPoint: AmplitudeOfferListingTileEntryPoint | null;
    itemAddress: string | null;
    location: AmplitudeOfferTileLocation | null;
    usp: string | null;
}

export interface IGetAmplitudeOfferSelectItemEventPropertiesParams {
    offer: IAmplitudeViewItemOffer;
    index: number;
    itemListId?: string;
    itemListName?: AmplitudeItemListName;
    listingTileContext?: IAmplitudeOfferListingTileContext;
}

export const getAmplitudeOfferSelectItemEventProperties = ({
    offer,
    index,
    itemListId,
    itemListName,
    listingTileContext
}: IGetAmplitudeOfferSelectItemEventPropertiesParams): Record<string, string | string[] | number | null> => ({
    ...getAmplitudeViewItemEventProperties({
        offer,
        itemListId,
        itemListName
    }),
    property_id: null,
    item_address: listingTileContext?.itemAddress ?? null,
    usp: listingTileContext?.usp ?? null,
    entry_point: listingTileContext?.entryPoint ?? null,
    location: listingTileContext?.location ?? null,
    index
});
